import LocalStorage from "./LocalStorage";

export default class FilterStorage {

  protected data = new Set();
  protected storage:LocalStorage;
  protected readonly key:string;

  constructor( key:string ) {
    this.key = key;
    this.storage = new LocalStorage( key );
    this.load();
  }

  load() {
    const data = this.storage.data;
    if ( data ) {
      this.data = new Set( data );
    }
  }

  save() {
    if ( this.data ) {
      this.storage.data = Array.from( this.data );
    }
  }

  get filters() {
    const [ data ] = Array.from( this.data );
    return data;
  }

  add( item:any ) {
    this.data.add( item );
    this.save();
  }

  delete( item:any ) {
    this.data.delete( item );
    this.save();
  }

  clear() {
    this.data = new Set();
    this.save();
  }
}
